module.exports = __webpack_public_path__ + "img/rlt.269ad06a.png";